import React from 'react'

const LinkedInIcon = () => {
  return (
    <div className='svg-icon'>
      <svg xmlns="http://www.w3.org/2000/svg" width="25.25" height="25.25" viewBox="0 0 25.25 25.25">
  <path id="Icon_awesome-linkedin" data-name="Icon awesome-linkedin" d="M23.446,2.25H1.8A1.811,1.811,0,0,0,0,4.07V25.68A1.811,1.811,0,0,0,1.8,27.5H23.446a1.816,1.816,0,0,0,1.8-1.82V4.07A1.816,1.816,0,0,0,23.446,2.25ZM7.631,23.893H3.889V11.843H7.637v12.05ZM5.76,10.2a2.17,2.17,0,1,1,2.17-2.17A2.171,2.171,0,0,1,5.76,10.2Zm15.9,13.7H17.917V18.031c0-1.4-.028-3.2-1.944-3.2-1.95,0-2.249,1.522-2.249,3.094v5.963H9.982V11.843h3.59v1.646h.051a3.942,3.942,0,0,1,3.545-1.944c3.788,0,4.492,2.5,4.492,5.743Z" transform="translate(0 -2.25)" fill="#0063ad"/>
</svg>

    </div>
  )
}

export default LinkedInIcon
